import { FC, useCallback } from "react";
import { AnyTask, Point } from "tm-shared/types";

import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import { AssignmentWithContext } from "@/pages/Assignments/AssignmentsPage/AssignmentPage.types";
import { ItemListView } from "@/shared/ui/ItemListView";
import { setAssignmentActiveCollapseId } from "@/store/slices/ui";

import { AssignmentBody } from "../AssignmentBody";
import { AssignmentHeader } from "../AssignmentHeader";

interface AssignmentPointListProps {
    assignmentsWithContext: AssignmentWithContext[];
    onOpenTasksInfoModal: (params: { task: AnyTask; point: Point }) => void;
}

export const AssignmentPointList: FC<AssignmentPointListProps> = ({
    assignmentsWithContext,
    onOpenTasksInfoModal,
}) => {
    const dispatch = useAppDispatch();

    const { activeCollapseId } = useAppSelector((s) => s.ui.assignments.page);

    const onChangeCollapse = useCallback(
        (id?: string | null) => {
            dispatch(setAssignmentActiveCollapseId(id ?? null));
        },
        [dispatch],
    );

    return (
        <ItemListView
            items={assignmentsWithContext}
            onChangeCollapse={onChangeCollapse}
            HeaderComponent={AssignmentHeader}
            BodyComponent={AssignmentBody}
            activeCollapse={activeCollapseId}
            bodyProps={{ onOpenTasksInfoModal }}
        />
    );
};
